export interface FontRequirementState {
    isReady: boolean;
    shouldLoad: boolean;
}

export function getFontRequirementState(
    requiredKey: string,
    loadedKey: string | null,
    readyKey: string | null,
): FontRequirementState {
    return {
        isReady: requiredKey === readyKey,
        shouldLoad: requiredKey !== loadedKey,
    };
}
